module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.0.0.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP1.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.0.1.0.box.535.208.523.36.q.95"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PP1.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.0.1.0.box.535.208.523.36.q.95"
    }
  }, [_vm._v("- "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("k ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("tW/r*. ")]), _vm._v("*/\"N"), _c('sup', [_vm._v(":")]), _vm._v(" ..V t . /\"% C")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.0.2.0.box.528.226.530.54.q.99"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PP1.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "107%",
      "text-align": "center"
    },
    attrs: {
      "id": "para.0.2.0.box.528.226.530.54.q.99"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP1.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.4.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.4.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP2"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP2.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP2.w.1.0.0"
    }
  }), _vm._v("F A LXi'O N O F")]), _c('a', {
    attrs: {
      "id": "GBS.PP2.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP2.w.2.1.0"
    }
  })]), _c('a', {
    attrs: {
      "id": "GBS.PP2.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP2.w.3.1.0"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PP2.w.3.1.0.1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP2.w.3.2.0"
    }
  }), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.0.3.0.box.0.526.1737.1792.q.101"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP2.w.4.0.0"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PP3"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.0.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic][merged small]",
      "src": "data/content-0001.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.0.0.0.1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page full_page_image",
    attrs: {
      "id": "ORIG-GBS.PP2"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.0.1.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "Image for page 1",
      "src": "data/content-0002.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.0.1.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PP3"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.2.0.0.box.202.283.1120.2068.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PP3.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.2.0.0.box.241.283.1055.155.q.60"
    }
  }, [_vm._v("Reviews of the "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("MacGregor ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Family ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Adventure ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Series ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Cayman ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Gold: ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Lost ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Treasure ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Devils ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Grotto ")]), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.0.2.0"
    }
  }), _vm._v("Book One")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP3.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em",
      "text-align": "center",
      "font-weight": "bold"
    },
    attrs: {
      "id": "para.2.0.1.box.300.478.940.47.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP3.w.0.3.0"
    }
  }), _vm._v("VOYA ")]), _c('b', [_vm._v("• ")]), _vm._v("Journal for Librarians • August 2000")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP3.w.0.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.2.0.2.box.213.531.1109.369.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP3.w.0.4.0"
    }
  }), _vm._v("\"Science fact and fiction based on folklore intertwine in this fast-paced story of pirate gold and adventure. In an increasingly rare story line, the family is intact, with parents who are intelligent and involved in the lives of their children....surely will appeal to older teens— mostly boys—looking for a blend of adventure and a bit of romance.\"—Pam Carlson")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP3.w.0.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em",
      "text-align": "center",
      "font-weight": "bold"
    },
    attrs: {
      "id": "para.2.0.3.box.303.963.924.49.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP3.w.0.5.0"
    }
  }), _vm._v("KLIATT ")]), _c('i', [_vm._v("• ")]), _vm._v("Journal for Librarians "), _c('b', [_vm._v("• ")]), _vm._v("May 2000")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP3.w.0.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.2.0.4.box.209.1016.1109.435.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP3.w.0.6.0"
    }
  }), _vm._v("\"In this quick-moving adventure story, teenagers who are expert scuba divers bump up against modern-day pirates....The author, an environmental biologist and college professor, shows his love and fierce protectiveness of natural resources and endangered species. This story is fun to read while making teens aware of environmental issues.\"—Sherri Forgash Ginsberg, Duke School for Children, Chapel Hill, NC")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP3.w.0.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "center",
      "font-weight": "bold"
    },
    attrs: {
      "id": "para.2.0.5.box.235.1501.1050.38.q.70"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP3.w.0.7.0"
    }
  }), _vm._v("Midwest ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Books ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Review ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("• ")]), _vm._v("\"Children's Bookwatch\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP3.w.0.6.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.2.0.6.box.207.1557.1108.160.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP3.w.0.8.0"
    }
  }), _vm._v("\"...Cayman ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Gold ")]), _vm._v("is a well crafted adventure with meticulous attention to accuracy in detail and highly recommended reading for teens and young adults.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP3.w.0.7.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "id": "para.2.0.7.box.724.1726.592.41.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP3.w.0.9.0"
    }
  }), _vm._v("—James Cox, Editor-in-Chief")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP3.w.0.8.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em",
      "text-align": "center",
      "font-weight": "bold"
    },
    attrs: {
      "id": "para.2.0.8.box.348.1817.824.38.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP3.w.0.10.0"
    }
  }), _vm._v("\"Kids Books\" • "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Northwest ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Metro ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Times ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP3.w.0.9.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.2.0.9.box.205.1869.1107.221.q.60"
    }
  }, [_vm._v("\"This riveting story combines historical events, hurricanes, daring escapades and some nasty bad guys and puts them all together in a way that will keep you on the edge of your seat until the final page.—Dale Knowles")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP3.w.0.10.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em",
      "text-align": "center",
      "font-weight": "bold"
    },
    attrs: {
      "id": "para.2.0.10.box.219.2139.1078.48.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP3.w.0.11.0"
    }
  }), _vm._v("\"Book Briefs\" • "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Sunday ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Oklahoman ")]), _vm._v("• Feb. 2000")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP3.w.0.11.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.2.0.11.box.202.2194.1109.157.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP3.w.0.12.0"
    }
  }), _vm._v("\".. .Billed as a young adult-family novel, this adventure "), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.1.0.0"
    }
  }), _vm._v("story offers suspense and some good lessons in conservation.\"—Kay Dyer")]), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.2.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.2.1.0.box.790.2320.704.195.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP4"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP4.w.0.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0003.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP4.w.0.0.0.1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP4.w.0.0.0.2"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP4.w.0.1.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PP4"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.3.0.0.box.233.298.1109.2065.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PP4.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em",
      "text-align": "center",
      "font-weight": "bold",
      "margin-bottom": "0"
    },
    attrs: {
      "id": "para.3.0.0.box.369.298.836.50.q.70"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Elephant ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Tears: ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Mask ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Elephant ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP4.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "center",
      "font-weight": "bold"
    },
    attrs: {
      "id": "para.3.0.1.box.680.359.212.34.q.70"
    }
  }, [_vm._v("Book Two")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP4.w.0.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.3.0.2.box.233.467.1106.270.q.60"
    }
  }, [_vm._v("\"An action-packed journey for young adults through the trials and triumphs of wildlife conservation in the African bush.\"—Dr. Delia and Mark Owens, Zoologists, Authors of "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Cry ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Kalahari, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Eye ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("El")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("ephant, ")]), _vm._v("and National Geographic film, "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("African ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Odyssey. ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP4.w.0.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em",
      "text-align": "center",
      "font-weight": "bold"
    },
    attrs: {
      "id": "para.3.0.3.box.286.796.1002.45.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP4.w.0.2.0"
    }
  }), _vm._v("VOYA ")]), _vm._v("• Journal for Librarians • December 2000")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP4.w.0.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.3.0.4.box.233.850.1107.316.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP4.w.0.3.0"
    }
  }), _vm._v(".. .portrays the teens' relationships with each other and with their parents as wholesome but realistic.. .respectfully depicts the native Africans and their tradition without glossing over their problems.. .descriptive narration is admirable—family-friendly realistic wildlife adventure.\"—Leah Sparks")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP4.w.0.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "center",
      "font-weight": "bold"
    },
    attrs: {
      "id": "para.3.0.5.box.258.1229.1056.45.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP4.w.0.4.0"
    }
  }), _vm._v("KLIATT ")]), _vm._v("• Journal for Librarians • September 2000")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP4.w.0.6.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.3.0.6.box.233.1281.1107.265.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP4.w.0.5.0"
    }
  }), _vm._v("\"... the author weaves an exciting adventure while stressing the importance of protecting the earth's dwindling resources and endangered animals. It is a powerful, enlightening novel that remains exciting without being didactic.\"—Sherri Forgash Ginsberg")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP4.w.0.7.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em",
      "text-align": "center",
      "font-weight": "bold"
    },
    attrs: {
      "id": "para.3.0.7.box.271.1611.1029.34.q.70"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP4.w.0.6.0"
    }
  }), _vm._v("Midwest ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Book ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Review ")]), _vm._v("• \"Children's Bookwatch\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP4.w.0.8.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.3.0.8.box.233.1662.1107.265.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP4.w.0.7.0"
    }
  }), _vm._v("\"Elephant ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Tears ")]), _vm._v("is a thriller adventure novel...superbly researched and written, "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Elephant ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Tears ")]), _vm._v("is one of those infrequent novels for young readers that are so easy to pick up, and so hard to put down! Also highly recommended is Trout's first adventure novel, "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Cayman ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Gold.\" ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP4.w.0.9.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "id": "para.3.0.9.box.750.1935.592.43.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP4.w.0.8.0"
    }
  }), _vm._v("—James Cox, Editor-in-Chief")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP4.w.0.10.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "center",
      "font-weight": "bold"
    },
    attrs: {
      "id": "para.3.0.10.box.234.2045.1106.45.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP4.w.0.9.0"
    }
  }), _vm._v("\"Kids Books\" • "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Northwest ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Metro ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Times ")]), _vm._v("• August 2000")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP4.w.0.11.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.3.0.11.box.234.2096.1106.267.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP4.w.0.10.0"
    }
  }), _vm._v("\"This is an action-filled thriller set in the plains of East Africa that you will want to read for the excitement factor as well as gaining a lot of insight into the problems of wildlife survival. I certainly enjoyed it, and I think you will also.—Dale Knowles")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP5"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP5.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PP5"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.4.0.0.box.374.1134.794.100.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PP5.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "127%",
      "text-indent": "1em",
      "text-align": "center",
      "font-weight": "bold"
    },
    attrs: {
      "id": "para.4.0.0.box.374.1134.794.100.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP5.w.0.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP6"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP6.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP7"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP7.w.0.0.0"
    }
  }), _vm._v("Falcon of Abydos")]), _c('a', {
    attrs: {
      "id": "GBS.PP7.w.0.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP7.w.0.2.0"
    }
  })]), _c('a', {
    attrs: {
      "id": "GBS.PP7.w.0.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP7.w.1.0.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP8"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP8.w.0.0.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP8.w.0.1.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP8.w.0.2.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP8.w.0.2.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP8.w.1.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP8.w.1.1.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP8.w.1.2.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP8.w.2.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page full_page_image",
    attrs: {
      "id": "ORIG-GBS.PP7"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PP8.w.2.1.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "Image for page 6",
      "src": "data/content-0004.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP8.w.2.1.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page full_page_image",
    attrs: {
      "id": "ORIG-GBS.PP8"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PP8.w.2.2.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "Image for page 7",
      "src": "data/content-0005.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP8.w.2.2.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PP9"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.8.0.0.box.472.535.622.90.q.100"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PP9.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "136%",
      "text-align": "center",
      "font-weight": "bold"
    },
    attrs: {
      "id": "para.8.0.0.box.472.535.622.90.q.100"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP8.w.2.3.0"
    }
  }), _vm._v("Dedication")]), _c('a', {
    attrs: {
      "id": "GBS.PP8.w.2.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP8.w.2.5.0"
    }
  })]), _c('a', {
    attrs: {
      "id": "GBS.PP8.w.2.6.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP8.w.2.7.0"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.8.1.0.box.729.781.108.61.q.90"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP8.w.2.8.0"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP9.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "118%",
      "text-align": "center",
      "font-weight": "bold"
    },
    attrs: {
      "id": "para.8.1.0.box.729.781.108.61.q.90"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP9"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP9.w.0.0.0"
    }
  }), _vm._v("for")]), _c('a', {
    attrs: {
      "id": "GBS.PP9.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP9.w.2.0.0"
    }
  })]), _c('a', {
    attrs: {
      "id": "GBS.PP9.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP9.w.3.1.0"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.8.2.0.box.652.983.261.98.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PP9.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "125%",
      "text-align": "center",
      "font-weight": "bold"
    },
    attrs: {
      "id": "para.8.2.0.box.652.983.261.98.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP9.w.3.2.0"
    }
  }), _vm._v("Keely")]), _c('a', {
    attrs: {
      "id": "GBS.PP9.w.3.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP10"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP10.w.0.0.0"
    }
  })]), _c('a', {
    attrs: {
      "id": "GBS.PP11"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP11.w.0.0.0"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PP11.w.0.0.0.1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP11.w.0.1.0"
    }
  }), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.8.3.0.box.394.1199.788.306.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PP9.w.3.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "109%",
      "text-align": "center"
    },
    attrs: {
      "id": "para.8.3.0.box.442.1199.675.49.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP11.w.0.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP11.w.0.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP11.w.0.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP11.w.0.5.0"
    }
  }), _vm._v("who would have loved")]), _c('a', {
    attrs: {
      "id": "GBS.PP11.w.0.6.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP11.w.0.7.0"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP9.w.3.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "109%",
      "text-align": "center"
    },
    attrs: {
      "id": "para.8.3.1.box.394.1279.788.67.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP11.w.0.8.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP11.w.0.9.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP11.w.0.10.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP11.w.0.11.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP11.w.0.12.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP11.w.0.13.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP11.w.0.14.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP11.w.0.15.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP11.w.0.16.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP11.w.0.17.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP11.w.0.18.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP11.w.0.19.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP11.w.0.20.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP11.w.0.21.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP11.w.0.22.0"
    }
  }), _vm._v("living among the gran"), _c('a', {
    attrs: {
      "id": "GBS.PP12"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP12.w.0.0.0"
    }
  }), _vm._v("deur")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP9.w.3.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "109%",
      "text-align": "center"
    },
    attrs: {
      "id": "para.8.3.2.box.639.1359.282.67.q.80"
    }
  }, [_vm._v("and glory")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP9.w.3.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "109%",
      "text-align": "center"
    },
    attrs: {
      "id": "para.8.3.3.box.541.1438.478.67.q.80"
    }
  }, [_vm._v("of ancient Egypt")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP13"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP13.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP13.w.0.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP13.w.0.0.0.2"
    }
  })]), _c('div', {
    staticClass: "flow"
  }), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page full_page_skipped",
    attrs: {
      "id": "ORIG-GBS.PP11"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP13.w.0.0.0.3"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a0fdb794","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content-0006.vue
// module id = 54
// module chunks = 0